import React from 'react'
import { IMaskInput } from 'react-imask'

import * as S from './styles'

/**
 * @typedef {'text' | 'number' | 'email' | 'password' | 'tel' | 'url' | 'search' | 'date' | 'time' | 'datetime-local' | 'month' | 'week' | 'file' | 'checkbox' | 'radio' | 'range' | 'color' | 'hidden' | 'submit' | 'reset' | 'button' | 'image'} InputType
 */

/**
 * @typedef {Object} InputProps
 * @property {string} [placeholder]
 * @property {React.ReactNode} [label]
 * @property {'filled' | 'default' | 'unstyled'} [variant]
 * @property {string | number | readonly string[]} [value]
 * @property {boolean} [disabled]
 * @property {InputType} [type]
 * @property {string} [mask]
 * @property {boolean} [withAsterisk]
 * @property {(e: React.FocusEvent<HTMLInputElement>) => void} [onBlur]
 * @property {(e: React.ChangeEvent<HTMLInputElement>) => void} [onChange]
 * @property {(e: React.KeyboardEvent<HTMLInputElement>) => void} [onKeyDown]
 * @property {boolean} [autoFocus]
 * @property {number} [maxLength]
 * @property {boolean | string | React.ReactNode} [error]
 * @property {React.ReactNode} [icon]
 * @property {React.ReactNode} [rightSection]
 * @property {React.Ref<HTMLInputElement>} [ref]
 * @property {number} [fontSize]
 * @property {string} [width]
 * @property {string} [className]
 */

/**
 * @param {InputProps} props
 */

export default function Input({
  placeholder,
  label,
  variant = 'filled',
  value,
  disabled,
  type = 'text',
  mask,
  withAsterisk = false,
  onBlur,
  onChange,
  onKeyDown,
  autoFocus,
  maxLength,
  error,
  icon,
  rightSection,
  ref,
  fontSize = 20,
  width,
  className,
  ...props
}) {
  return (
    <S.Input
      fontSize={`${fontSize}px`}
      className={className}
      icon={icon}
      rightSection={rightSection}
      error={error}
      maxLength={maxLength}
      type={type}
      autoFocus={autoFocus}
      placeholder={placeholder}
      label={label}
      disabled={disabled}
      variant={variant}
      radius="xl"
      w={width}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      withAsterisk={withAsterisk}
      component={IMaskInput}
      mask={mask}
      ref={ref}
      {...props}
    />
  )
}
